import { inject, Injectable } from '@angular/core';
import { Activity, Message } from '@clientwire/api';
import { ActiveConversationStore, IdentityStore, UserStore } from '../stores';
import { WireApiService } from './wire-api.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ActivityService {
  readonly #wireApiService = inject(WireApiService);
  readonly #activeConversationStore = inject(ActiveConversationStore);
  readonly #userStore = inject(UserStore);
  readonly #identityStore = inject(IdentityStore);

  readonly #translateService = inject(TranslateService);

  async handleMessageSeenActivity(message: Message) {
    if (!message.sequence) {
      throw Error(this.#translateService.instant('SHARED.SERVICES.ACTIVITY.MESSAGE_SEEN_ERROR'));
    }

    const participantId = this.findParticipantIdForConversation(message.conversationId);
    if (!participantId) {
      return;
    }

    await this.#wireApiService.participantsApi.updateParticipantActivity({
      conversationId: message.conversationId,
      participantId: participantId,
      participantActivityRequest: {
        activity: Activity.MessageSeen,
        lastMessageSequenceSeen: message.sequence,
      },
    });
  }

  async handleConversationOpenActivity(conversationId: string) {
    const participantId = this.findParticipantIdForConversation(conversationId);
    if (!participantId || !conversationId) {
      return;
    }

    await this.#wireApiService.participantsApi.updateParticipantActivity({
      conversationId: conversationId,
      participantId: participantId,
      participantActivityRequest: {
        activity: Activity.HasConversationOpen,
      },
    });
  }
  async handleIsTypingActivity(
    conversationId: string,
    userType: 'me' | 'other',
    messageSourceId?: string
  ) {
    if (userType === 'me') {
      const participantId = this.findParticipantIdForConversation(conversationId);
      if (!participantId || !conversationId) {
        return;
      }

      await this.#wireApiService.participantsApi.updateParticipantActivity({
        conversationId: conversationId,
        participantId: participantId,
        participantActivityRequest: {
          activity: Activity.IsTyping,
          sourceId: messageSourceId,
        },
      });
    }
  }

  findParticipantIdForConversation(conversationId: string): string | undefined | null {
    return this.#identityStore.identityType() === 'user'
      ? this.#activeConversationStore.findParticipantInConversationByUserId(
          conversationId,
          this.#userStore.id()
        )?.id
      : this.#identityStore.clientParticipantId();
  }
}
